import React from 'react';
import { injectIntl } from 'react-intl';
import { makeStyles } from 'tss-react/mui';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import {
  slidingToggleButtonNoBorder,
  slidingToggleGroupNoBorder
} from '../../../../components/SlidingToggleButton/noBorderStyles';

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center'
  },
  toggleGroup: {
    position: 'relative',
    backgroundColor: '#f3f5fb',
    borderRadius: '8px !important',
    padding: 6,
    zIndex: 0,
    ...slidingToggleGroupNoBorder
  },
  toggleButton: {
    ...slidingToggleButtonNoBorder,
    borderRadius: '8px !important',
    padding: '0 20px',
    fontWeight: 'bold',
    fontSize: 14,
    height: 36,
    minWidth: 120,
    color: '#616161',
    textTransform: 'none',
    zIndex: 2,
    backgroundColor: 'transparent',
    transition: 'color 0.25s ease !important',
    WebkitTapHighlightColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(57, 102, 248, 0.04)',
      border: 'none !important',
      borderColor: 'transparent !important',
      boxShadow: 'none'
    }
  },
  selected: {
    color: '#ffffff !important',
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  slidingIndicator: {
    position: 'absolute',
    top: 6,
    bottom: 6,
    left: 6,
    width: 'calc(50% - 6px)',
    backgroundColor: '#3966f8',
    borderRadius: 8,
    boxShadow: '0 4px 10px rgba(57, 102, 248, 0.2)',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    zIndex: 1
  }
}));

const ModeToggleButton = ({ intl, mode, setMode, disabled }) => {
  const { classes } = useStyles();

  const handleChange = (event, newMode) => {
    if (newMode !== null) {
      setMode(newMode);
    }
  };

  const getIndex = val => (val === 'edit' ? 1 : 0);

  return (
    <div className={classes.root}>
      <ToggleButtonGroup
        value={mode}
        exclusive
        onChange={handleChange}
        aria-label="mode toggle"
        classes={{ root: classes.toggleGroup }}
      >
        <div
          className={classes.slidingIndicator}
          style={{
            transform: `translateX(${getIndex(mode) * 100}%)`
          }}
        />
        <ToggleButton
          value="create"
          classes={{ root: classes.toggleButton, selected: classes.selected }}
          disabled={disabled}
        >
          {intl.formatMessage({ id: 'create-client' })}
        </ToggleButton>
        <ToggleButton
          value="edit"
          classes={{ root: classes.toggleButton, selected: classes.selected }}
          disabled={disabled}
        >
          {intl.formatMessage({ id: 'existing-client' })}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default injectIntl(ModeToggleButton);
